import React from 'react';

import Card from '../../common/Card';
import PasswordForm from './PasswordForm';
import UserForm from './UserForm';

const SettingsMain = (props) => {
	const { 
		updatePassword, 
		updateUser, 
		updateErrorMessage, 
		passwordErrorMessage, 
		user,
		accountPanel,
		passPanel,
	} = props;

	return (
		<div className="settings__main">
			<Card>
				{ accountPanel && <h2>{accountPanel.title}</h2> }
				{ accountPanel && <p>{accountPanel.message}</p> }
				<UserForm 
					initialValues={user}
					onSubmit={values => updateUser(values)}
					errorMessage={updateErrorMessage} />
			</Card>

			<Card>
				{ passPanel && <h2>{passPanel.title}</h2> }
				{ passPanel && <p>{passPanel.message}</p> }
				<PasswordForm 
					initialValues={{id: user.id}}
					onSubmit={values => updatePassword(values)}
					errorMessage={passwordErrorMessage} />
			</Card>
		</div>
	);
};

export default SettingsMain;


// WEBPACK FOOTER //
// ./src/components/routes/Settings/SettingsMain.js